import { useEffect, useState } from "react"

// providers
import { useAuthDataContext } from "@/_providers/Auth"
import { trans } from "@/_providers/Translation"

// libraries
import { Button, Menu, MenuItem } from "@mui/material"
import { useSnackbar } from "notistack"

// images
import optionsImage from "@/assets/img/chat/icons/options.svg"
import editImage from "@/assets/img/chat/icons/edit.svg"
import removeImage from "@/assets/img/chat/icons/remove.svg"
import seenImage from "@/assets/img/chat/icons/seen.svg"

// helpers
import Api from "@/_helpers/Api"

export default function SingleMessage({ message, index, onDelete, onEdit }) {
  const auth = useAuthDataContext()
  const { enqueueSnackbar } = useSnackbar()

  const [openOptions, setOpenOptions] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(false)
  const [messageText, setMessageText] = useState(message.message || "")

  useEffect(() => {
    return () => {
      if (editMode) {
        handleCancelEditMode()
      }

      if (loading) {
        setLoading(false)
      }

      if (openOptions) {
        setOpenOptions(null)
      }
    }
  }, [])

  function handleChangeText(e) {
    setMessageText(e.target.value)
  }

  const createMarkup = (html) => {
    return {
      __html: String(html).replaceAll("\n", "<br/>"),
    }
  }

  function handleDeleteMessage() {
    setLoading(true)
    Api.post("messages/delete", {
      id: message.id,
      receiver_id: message.receiver_subject.id,
      receiver_tenant_id: message.receiver_subject.receiver_tenant_id,
    })
      .then(() => {
        onDelete(message.id)
        enqueueSnackbar("Съобщението е изтрито успешно!", {
          variant: "success",
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  function handleCancelEditMode() {
    setEditMode(false)
    setMessageText(message.message || "")
  }

  function handleEditMessage() {
    setLoading(true)

    Api.post("messages/edit", {
      id: message.id,
      receiver_id: message.receiver_subject.id,
      receiver_tenant_id: message.receiver_subject.receiver_tenant_id,
      body: messageText,
    })
      .then((res) => {
        handleCancelEditMode()
        onEdit(message.id, res.data.data.body)
        enqueueSnackbar("Съобщението е редактирано успешно!", {
          variant: "success",
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div
      key={`msg-${message.id}-${message.created_at || ""}-${index}`}
      className={[
        "content",
        message.author &&
        message.author.id === auth.id() &&
        message.author.type === auth.type()
          ? "reverse"
          : "",
      ].join(" ")}
      style={
        loading
          ? {
              opacity: 0.4,
              pointerEvents: "none",
            }
          : {}
      }
    >
      <div className="wrap">
        {message.author && message.author.id === auth.id() ? (
          <>
            {editMode ? (
              <div className="edit-message">
                <textarea
                  type="text"
                  name="message"
                  placeholder={trans("random.writeMessage")}
                  defaultValue=""
                  onChange={handleChangeText}
                  value={messageText}
                  autoFocus
                />
                <div className="buttons">
                  <button
                    className="button-default button-small"
                    onClick={handleCancelEditMode}
                  >
                    Отказ
                  </button>
                  <button
                    className="button-add button-small"
                    disabled={
                      !messageText.trim().length ||
                      messageText.trim() === (message.message || "").trim()
                    }
                    onClick={() => {
                      handleEditMessage()
                    }}
                  >
                    Запази
                  </button>
                </div>
              </div>
            ) : (
              <>
                <div
                  className="cloud sent"
                  dangerouslySetInnerHTML={createMarkup(
                    (typeof message.message === "string"
                      ? message.message
                      : "") || "",
                  )}
                />
                <Button
                  className="options"
                  onClick={(e) => setOpenOptions(e.currentTarget)}
                >
                  <img src={optionsImage} alt="options" />
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={openOptions}
                  open={Boolean(openOptions)}
                  onClose={() => setOpenOptions(null)}
                  slotProps={{
                    list: {
                      "aria-labelledby": "basic-button",
                    },
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      setOpenOptions(null)
                      setEditMode(true)
                    }}
                    sx={{
                      gap: "10px",
                    }}
                  >
                    <img
                      src={editImage}
                      alt="edit"
                      style={{
                        width: "12px",
                      }}
                    />
                    Редактиране на съобщението
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenOptions(null)
                      handleDeleteMessage()
                    }}
                    sx={{
                      color: "#EC5252",
                      gap: "10px",
                    }}
                  >
                    <img
                      src={removeImage}
                      alt="remove"
                      style={{
                        width: "12px",
                      }}
                    />
                    Изтриване на съобщението
                  </MenuItem>
                </Menu>
              </>
            )}
          </>
        ) : (
          <div
            className="cloud"
            dangerouslySetInnerHTML={createMarkup(
              (typeof message.message === "string" ? message.message : "") ||
                "",
            )}
          />
        )}
      </div>
      <div className="time">
        <span className="timer" data-date={message.created_at}>
          {message.published}
          {message.author &&
          message.author.id === auth.id() &&
          message.author.type === auth.type() &&
          message.read_at ? (
            <img src={seenImage} title="прочетено" />
          ) : (
            ""
          )}
        </span>
      </div>
    </div>
  )
}
